import i18n from 'i18next';

export const isFrench = (): boolean => i18n.language === 'fr';
